export default "__VITE_ASSET__Csxrzpwf__"